<ds-promo-badge
  tone="purple"
  iconSrc="/assets/icons/star.svg"
  iconAlt="star"
  label="Expert's choice"
/>
